export const toHoldingServiceSortDesc = (desc: boolean): boolean => !desc;
